import { render, staticRenderFns } from "./ref.vue?vue&type=template&id=bd5b735c&"
import script from "./ref.vue?vue&type=script&lang=js&"
export * from "./ref.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports